import { useEffect } from 'react';
// import { usePageConfig } from '@tmsw/powerups.config.page.provider';
import { CTAButton } from '@tmsw/powerups.ui.buttons.cta-button';
import { useStore } from '@tmsw/powerups.store';
import { useTranslation } from '@tmsw/powerups.intl.hooks.use-translation';
import './ScanConfirmation.css';
import { usePageNavigation } from '../../hooks/usePageNavigation';
import { HeaderH1 } from '../../components/promo/HeaderH1';
// import useResetFocus from '../../hooks/useResetFocus';

export const ScanConfirmation = () => {
  const { __t } = useTranslation();
  // const { pagesMap } = usePageConfig();
  const parentNode = 'SCAN_CONFIRMATION';
  const pageData = __t(parentNode);
  console.log('ScanConfirmation pageData=', pageData);
  const { goToPage } = usePageNavigation();

  const gameCharacter = useStore((state) => state.gameCharacter);
  // const setPageTitle = useStore((state) => state.setPageTitle);
  // const showSettingsPanel = useStore((state) => state.showSettingsPanel);
  // const inPortrait = useStore((state) => state.inPortrait);
  // const isPauseEnabled = useStore((state) => state.isPauseEnabled);

  // useResetFocus([showSettingsPanel, inPortrait, isPauseEnabled]);

  const characters = __t('characters', 'CHARACTER_SELECTION');
  const characterObj = characters.find(
    (c: LocaleJson.Character) => c.slug === gameCharacter
  );

  console.log('gameCharacter=', gameCharacter, 'characterObj=', characterObj);

  // TODO: Confirm pageTitle announcer works now that this is a page
  // useEffect(() => {
  //   if (!showSettingsPanel && !isPauseEnabled && inPortrait) {
  //     setPageTitle(__t('pageTitle', 'SCAN_CONFIRMATION'));
  //   }
  //   /* eslint-disable-next-line react-hooks/exhaustive-deps */
  // }, [showSettingsPanel, inPortrait, isPauseEnabled]);
  const setPageTitle = useStore((state) => state.setPageTitle);
  const showSettingsPanel = useStore((state) => state.showSettingsPanel);
  const isPauseEnabled = useStore((state) => state.isPauseEnabled);
  const inPortrait = useStore((state) => state.inPortrait);

  useEffect(() => {
    setPageTitle(__t('pageTitle', parentNode));
  }, [showSettingsPanel, isPauseEnabled, inPortrait]);

  return (
    <section
      id="scan-confirmation-container"
      className="scan-interrupter"
      role="dialog"
      aria-modal="true"
      style={{
        backgroundImage: `url(${__t('backgrounds.main', 'GENERAL')})`,
      }}
    >
      <div className="scan-interrupter-content">
        <div className="scan-confirmation-wrapper">
          <HeaderH1 textValue={pageData.h1} />
          <div
            className="character-preview-box"
            aria-label={characterObj?.ariaLabel}
            role="img"
          >
            <img
              src={characterObj?.imgSrc}
              className="character-preview-sprite-image"
              data-character={characterObj?.slug}
              alt={characterObj?.ariaLabel}
            />
            <div
              className="character-preview-sprite-shadow"
              aria-hidden="true"
            ></div>
          </div>
          <div className="scan-confirmation-button-container">
            <CTAButton
              className="cta-btn"
              onClick={() => {
                goToPage('GAME_INSTRUCTIONS');
              }}
              primary
              intlKey={'buttons.next'}
              parentNode={'GENERAL'}
            />
            <CTAButton
              className="cta-btn--link"
              onClick={() => goToPage('CHARACTER_SELECTION')}
              primary
              intlKey={'buttons.selectCharacter'}
              parentNode={'GENERAL'}
            />
          </div>
          {/* TODO: Remove when done debugging */}
          {/* <div>
            <button onClick={() => setCharacterIndex(Math.max(0, Math.min(characterIndex - 1, 13)))}>Prev char</button>
            <button onClick={() => setCharacterIndex(Math.max(0, Math.min(characterIndex + 1, 13)))}>Next char</button>
            <p>{gameCharacter}</p>
          </div> */}
        </div>
      </div>
    </section>
  );
};
